export default __webpack_public_path__ + "static/media/maure_de_bretagne12.e4da5b53.jpg";